import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: unset;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.SMALL})`} {
    width: 100%;
  }
`;

export const ListingItemContainer = styled.div`
  display: grid;
  flex-wrap: wrap;
  margin-bottom: 20px;
  justify-content: space-around;
  width: 100%;
  grid-auto-rows: auto;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 0px 17px;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 10px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    grid-template-columns: 960px;
    grid-template-rows: auto;
    grid-auto-rows: auto;
    gap: 0px;
    width: auto;
    justify-content: flex-start;
    padding-left: 0;
    padding-right: 0;
    margin-top: 0px;
  }
`;

export const TourCardWrapper = styled.div<{
  initialItem?: boolean;
}>`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  ${({ initialItem }) => !initialItem && 'margin-top: 10px'};
`;

export const ListingCampaignBanner = styled.div`
  max-width: 960px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 1003px;
    width: 100%;
    margin: 0 auto 10px auto;
    & > div {
      padding: 0 !important;
    }
  }

  @media (max-width: 1019px) {
    max-width: 660px;
    width: 100%;
    margin: 0 auto 10px auto;
  }

  @media only screen and (max-width: 690px) {
    width: 100%;
    max-width: 93%;
  }
`;

export const SEOWrapper = styled.div`
  grid-row: 2/3;
  grid-column: 1/3;
  max-width: 1240px;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 100%;
    padding: 0px 15px 0 15px;
  }
`;

export const ListWrapper = styled.div`
  width: 100%;
  margin: 0 auto 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
  justify-content: center;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin: 0 auto 0 auto;
    display: grid;
    grid-template-columns: 260px 960px;
    justify-content: center;
    padding: 0 100px;
    gap: 0 20px;
  }
`;

export const SkeletonContainer = styled.div`
  width: 960px;
  display: grid;
  margin-top: 1.4rem;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
    justify-items: center;
  }
`;

export const SearchBarWrapper = styled.div`
  border-bottom: 2px solid ${({ theme }) => theme.palette.white};
  padding-bottom: 12px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-bottom: 0;
    border-bottom: 0;
  }
`;
export const SepareteBottom = styled.div`
  padding-top: 20px;
`;
export const SelectedSegmentsContainer = styled.div`
  margin: 0 10px 0px 10px;
`;
